import { ExamSessionExamineeMonitorList } from '@exam-center/proctoring-details';
import { Flex, PaperSection } from '@shared/components';

export default function ProctoringExamSessionDetailsPage() {
  return (
    <Flex sx={{ flexDirection: 'column', height: '100%', overflow: 'auto' }}>
      <Flex sx={{ flex: 1, p: (theme) => theme.spacing(6) }}>
        <PaperSection title='รายชื่อผู้เข้าสอบ' sx={{ height: 'fit-content' }}>
          <Flex
            sx={(theme) => ({
              flexDirection: 'column',
              gap: theme.spacing(6),
              p: theme.spacing(6),
            })}
          >
            <ExamSessionExamineeMonitorList />
          </Flex>
        </PaperSection>
      </Flex>
    </Flex>
  );
}
